import { useQuery } from 'react-query'
import { getCreditPolicy } from 'services/api'

export const useCreditPolicyGet = (id: number | string | null) => {
  return useQuery([`creditPolicy-${id}`], () => getCreditPolicy(id), {
    refetchOnWindowFocus: false,
  })
}
